import { supabase } from '../../../lib/supabaseClient';
import { ApiResponse } from '../../../types/api';
import { AtsApplication, UpdateApplicationStatusRequest, UpdateApplicationStatusResponse } from '../types';
import { handleEdgeFunctionError } from '../../../utils/edgeFunctionUtils';

export async function getAtsApplicationsWithEdgeFunction(jobId: string): Promise<ApiResponse<AtsApplication[]>> {
  try {
    const { data, error } = await supabase.functions.invoke('get-ats-applications', {
      body: { jobId },
    });

    if (error) {
      console.error('[Edge Function Error] getAtsApplications:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: [], error: extractedError };
    }

    return { data: data?.data || [], error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] getAtsApplications:', err);
    return { data: [], error: err };
  }
}

export async function updateApplicationStatusWithEdgeFunction(payload: UpdateApplicationStatusRequest): Promise<ApiResponse<UpdateApplicationStatusResponse>> {
  try {
    const { data, error } = await supabase.functions.invoke('update-application-status', {
      body: payload,
    });

    if (error) {
      console.error('[Edge Function Error] updateApplicationStatus:', error);
      const extractedError = await handleEdgeFunctionError(error);
      return { data: null, error: extractedError };
    }

    return { data: data || null, error: data?.error || null };
  } catch (err) {
    console.error('[Edge Function Exception] updateApplicationStatus:', err);
    return { data: null, error: err };
  }
}
